import { JetView } from 'webix-jet';

/**
 * FilterQualifyingView class extends JetView to create a filter form.
 */
export default class FilterQualifyingView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section with a text input for description
        const left = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'text',
                    name: 'Description', // Name of the input field
                    label: "<span class='icon-file-text1'></span>" + _('Descripción'), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Descripción'), // Placeholder text
                },
            ],
        };

        // Center-left section with a richselect for type
        const center_left = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'richselect',
                    name: 'Type', // Name of the input field
                    label: _('Tipo'), // Label for the select
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the select
                        { id: '0', value: _('Regional') },
                        { id: '1', value: _('Tipo Punto') },
                    ],
                },
            ],
        };

        // Center-right section with a richselect for activation status
        const center_right = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'richselect',
                    name: 'IsActivate', // Name of the input field
                    label: _('Estado'), // Label for the select
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the select
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                },
            ],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 100,
            rows: [],
        };

        // Button section with Clear and Consult buttons
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button label
                    autowidth: true, // Button width adjusts automatically
                    click: () => {
                        // Clear button click event
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button label
                    type: 'form', // Button type
                    autowidth: true, // Button width adjusts automatically
                    click: () => {
                        // Consult button click event
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('qualifying:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Upper section containing the input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1', // Responsive behavior
                    margin: 10,
                    cols: [left, center_left, center_right],
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form', // Form view
            scroll: 'y', // Vertical scrolling enabled
            rows: [upper_section, buttons], // Rows in the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
